import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCallouts } from '../../clients/qualityClient';
export const fetchCallouts = createAsyncThunk('callouts/fetchAll', () => {
  return getCallouts();
});
const initialState = {
  list: [],
  requestState: 'UNINITIALIZED'
};
export const calloutsSlice = createSlice({
  name: 'callouts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCallouts.pending, state => {
      state.requestState = 'PENDING';
    }).addCase(fetchCallouts.fulfilled, (state, action) => {
      state.requestState = 'SUCCEEDED';
      state.list = action.payload;
    }).addCase(fetchCallouts.rejected, state => {
      state.requestState = 'FAILED';
    });
  }
});
export default calloutsSlice.reducer;
export const selectCallouts = state => state.callouts.list;